import * as React from 'react'
import { navigate, type GatsbyBrowser } from 'gatsby'
import Layout from './src/components/layout'
import { Providers } from './src/components/providers'
import NoPermissionsPage from './src/components/NoPermissionsPage'
import LoginPage from './src/components/LoginPage'
import ReactDOM from 'react-dom/client'
import '@mantine/core/styles.layer.css'
import '@mantine/notifications/styles.layer.css'
import '@mantine/charts/styles.layer.css'
import 'mantine-react-table-open/styles.css'
import './src/styles/global.css'
import 'react-pdf/dist/Page/TextLayer.css'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import { useIsMember } from './src/hooks/useIsMember'
import { LoadingOverlay } from '@mantine/core'
import { useAuth0 } from '@auth0/auth0-react'
import posthog from 'posthog-js'
import SelfEnrollmentLayout from './src/components/selfEnrollmentLayout'
import BlankLayout from './src/components/blankLayout/oneTimeLinkLayout'
import { useEffect } from 'react'
import { beforeSend, maskEmails } from './src/utils/posthog'

if (process.env.GATSBY_POSTHOG_KEY) {
  posthog.init(process.env.GATSBY_POSTHOG_KEY, {
    api_host: `https://eu.i.posthog.com`,
    person_profiles: `identified_only`, // or 'always' to create profiles for anonymous users as well
    capture_pageview: false,
    capture_pageleave: false,
    before_send: beforeSend,
    session_recording: {
      maskTextFn: maskEmails,
      maskInputFn: maskEmails,
    },
  })
  console.log({
    key: process.env.GATSBY_POSTHOG_KEY,
    api_host: `https://eu.i.posthog.com`,
    person_profiles: `identified_only`, // or 'always' to create profiles for anonymous users as well
  })
} else {
  console.warn(`No PostHog key provided.`)
}

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => {
  return <Providers>{element}</Providers>
}

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  const { isAuthenticated, isLoading } = useAuth0()
  const isMember = useIsMember()

  useEffect(() => {
    if (window.location.pathname === `/` && isAuthenticated) {
      navigate(`/patients`)
    }
  }, [])

  if (window.location.pathname.startsWith('/enroll/')) {
    return <SelfEnrollmentLayout {...props}>{element}</SelfEnrollmentLayout>
  }

  if (
    window.location.pathname.startsWith('/one-time') ||
    window.location.pathname.startsWith('/ote') ||
    window.location.pathname.startsWith('/mobile')
  ) {
    return <BlankLayout {...props}>{element}</BlankLayout>
  }

  if (isLoading) {
    return <LoadingOverlay visible={isLoading} />
  } else if (!isAuthenticated) {
    // Never start the Auth0 login flow without user interaction, see LoginPage.
    return <LoginPage />
  } else if (isAuthenticated && !isMember) {
    return <NoPermissionsPage />
  } else {
    return <Layout {...props}>{element}</Layout>
  }
}

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container)
    root.render(element)
  }
}
